export type ComparableSessionModelState = {
  agent?: string
  model?: { providerID: string; modelID: string }
  variant?: string | null
  source?: "message" | "session" | "user"
  messageID?: string
}

export function sameSessionModelState(
  current: ComparableSessionModelState | undefined,
  next: ComparableSessionModelState,
) {
  return (
    current !== undefined &&
    current.agent === next.agent &&
    current.model?.providerID === next.model?.providerID &&
    current.model?.modelID === next.model?.modelID &&
    (current.variant ?? null) === (next.variant ?? null) &&
    current.source === next.source &&
    current.messageID === next.messageID
  )
}

export function resolveExistingSessionModelState<T>(input: {
  server: T | undefined
  cached: T | undefined
  provisional: boolean
}) {
  if (input.server !== undefined) return input.server
  if (input.provisional) return input.cached
  return undefined
}
